import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthProvider";
import api from "../api/axiosInstance";

const ProfileContext = createContext(null);

export const ProfileProvider = ({ children }) => {
  const [profile, setProfile] = useState(null);
  const keycloakInitialized = useAuth().didInitialize;

  useEffect(() => {
    api.get('/users/me')
      .then(response => {
        setProfile(response.data);
      })
      .catch(error => {
        console.error("Failed to fetch user profile:", error);
      });
  }, [keycloakInitialized]);

  return (
    <ProfileContext.Provider
      value={profile}
    >
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfile = () => useContext(ProfileContext);
